import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { themeColor } from "../../../design-system/themeColor";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Chip = styled.div<{ $fullWidth: boolean; $layout: "default" | "measure"; $surface: "tinted" | "white" }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
  min-width: 0;
  justify-content: ${({ $layout }) => ($layout === "measure" ? "space-between" : "flex-start")};
  padding: ${spacing[1]} ${spacing[2.5]};
  border: 1px solid ${themeColor((c) => c.border.stroke)};
  border-radius: ${borderRadius.full};
  background: ${({ $surface, ...props }) =>
    $surface === "white" ? themeColor((c) => c.background.primary)(props) : themeColor((c) => c.background.secondary)(props)};
  color: ${themeColor((c) => c.text.primary)};
  ${typographyMixin("caption", 4)}
`;

export const Content = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  min-width: 0;
`;

export const ContentButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  min-width: 0;
  margin: 0;
  padding: ${spacing[0]};
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: ${spacing[0.5]};
  }
`;

export const Label = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Actions = styled.span<{ $layout: "default" | "measure" }>`
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: ${({ $layout }) => ($layout === "measure" ? spacing[3] : spacing[0])};
`;

export const TrailingContent = styled.span<{ $layout: "default" | "measure" }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  margin-left: ${({ $layout }) => ($layout === "measure" ? spacing[0] : spacing[2])};
`;

export const RemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin: 0;
  padding: ${spacing[0]};
  border: 0;
  background: transparent;
  color: ${themeColor((c) => c.text.secondary)};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: ${spacing[0.5]};
  }
`;
